var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',{attrs:{"prop":"id","label":"#","width":"70","fixed":"","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n    "+_vm._s(scope.row.id)+"\n  ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }